import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core'; 
import { CommonModule} from '@angular/common';
import { TestnurseComponent } from './testnurse.component';
import { RouterModule, Routes } from '@angular/router';
import { Testnurse2Component } from './testnurse2/testnurse2.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthService } from '../../../../../src/app/shared/auth/auth.service';
import { AuthGuard } from '../../../../../src/app/shared/auth/auth-guard.service';
import { ActorService } from '../../services/actor.service';
import { DOCService } from '../../services/doc.service';
import { HCPService } from '../../services/hcp.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NurseCustomizerComponent } from '../testnurse/layout/customizer/nursecustomizer.component';
import { NurseNavbarComponent } from '../testnurse/layout/navbar/nursenavbar.component';
import { NurseFooterComponent } from '../testnurse/layout/footer/nursefooter.component';
import { LoginService } from '../../services/login.service';
import { MyScheduleManagerShortComponent } from '../testnurse/testnurse2/myschedulemanager/myschedulemanagershort.component';
import { MyScheduleManagerComponent, JobApplicationsInfoPipe } from '../testnurse/testnurse2/myschedulemanager/myschedulemanager.component';
import { MyJobsPendingComponent } from '../testnurse/testnurse2/myschedulemanager/myjobspending.component';
import { DocRenewAlertsInfoComponent } from '../testnurse/alerts/docrenewals/docrenewalertsinfo.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../shared/shared.module'; // trigger build
import { CodeTypeValueComponent } from '../../custumcomponents/codetypes/codetypevalue.component';
import { CustomDataByRequestTypeComponent } from '../../custumcomponents/ddlbyrequesttype/customdatabyrequesttype.componenet';
import { AutoSearchComponent } from '../../custumcomponents/autosearch/autosearch.component';
import { DataGrid } from '../../custumcomponents/datagrid/datagrid.component';
import { Format } from '../../custumcomponents/datagrid/format';
import { OrderBy } from '../../custumcomponents/datagrid/orderby';
import { SearchComponent } from '../../custumcomponents/search/search.component';
import { DetailGrid } from '../../custumcomponents/detailgrid/detailgrid.component';
import { SplitPipe } from '../../pipes/split.pipe';
import { NgbdUploadActorImageModal } from '../testnurse/profile/modals/uploadactorimage/ngbuploadactorimage.modal';
import { ActorImageInfoComponent } from '../testnurse/profile/imageinfo/imageinfo.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TestnurseRoutingModule } from './testnurse-routing.module';
import { MyIdentitiesComponent } from './profile/identitiesinfo/myidentities/myidentities.component';

import { AllCertificateListComponent } from '../testnurse/profile/allcertificatesview/allcertificatesview.component';
import { AllCertificatesViewPipe } from '../../pipes/actors/allcertificatesview.pipe';
import { NurseProfileComponent } from '../testnurse/profile/nurseprofile.component';


import { CertificationsV2InfoComponent } from '../testnurse/profile/version2/certificationsv2/certificationsv2.component';
import { DriverV2InfoComponent } from '../testnurse/profile/version2/driverinfov2/driverv2.component';
import { EducationInfoV2Component } from '../testnurse/profile/version2/educationinfov2/educationinfov2.component';
import { EmployeeHistoryInfoV2Component } from '../testnurse/profile/version2/employeehistoryinfov2/employeehistoryinfov2.component';
import { MedicalFitnessInfoV2Component } from '../testnurse/profile/version2/medicalfitnessinfov2/medicalfitnessinfov2.component';
import { ActorFormsV2Component } from '../testnurse/actorforms/version2/forms/actorformsv2.component';
import { ResumeUploadComponent } from '../testnurse/profile/version2/resumeupload.component';
import { DriverInfoV3Component } from '../testnurse/profile/identitiesinfo/driverinfov3.component';

import { LocationComponent } from '../testnurse/profile/version2/specialties/location.component';
import { Shiftsinfov2Component } from '../testnurse/profile/version2/specialties/shiftsinfov2.component';
import { Equipmentinfov2Component } from '../testnurse/profile/version2/equipment/equipmentinfov2.component';
import { SpecialtyInfoV2Component } from '../testnurse/profile/version2/specialties/specialtypref.component';
import { EmploymentTypeComponent } from '../testnurse/profile/version2/Employmenttype/employmenttype.component';
import { CustomDateTimeService } from '../../services/datetime.service';
import { ActorIdentitiesPipe, ServiceCategoryPipe, ConsultantMapPipe, DoctorListPipe, PatientListPipe, ScansPipe, PickPipe, CodeTypePipeNew, CodeValuesPipeNew, UsersListPipe, OocytePipe, ActivitesPipe, PickPipe2, MedicinePipe, TestPipe, TestViewPipe, InseminationPipe, GradingPipe, EtPipe, SemanPipe, PregencyTrackerPipe, BillingPipe, Servicebillpipe, OocyteAbPipe, Approvallistpipe, ExpenseVoucherpipe, IahPipe, ItemsIahpipe, Storelistpipe, ConsumptionEntrypipe, Drugslistpipe, Providerlistpipe, Externallistpipe, Refundslistpipe, AccessRightPipe, MaterialSpecpipe, PatientListPipe2, } from '../../pipes/actors/actorIdentity.pipes';
import { ActorFormsV3Component } from '../testnurse/actorforms/version3/forms/actorformsv3.component';
import { CataloguePipe, CredentialTypePipe } from '../../pipes/masters/credentialtype.pipe';

//import { ActorFormsV3Component } from '../testnurse/actorforms/version3/forms/actorformsv3.component';


import { NgbMyScheduleModal } from './testnurse2/myschedulemodal/myschedule.modal';

import { MappedRegistriesByNurseInfoPipe } from '../../pipes/registry/mappedregistriesbynurse.pipe';
import { FDService } from '../../services/fd.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

import { NgbActorDocsModal } from './profile/modals/actordocs/actordocs.modal';
import { NgbCertificationsinfoModal } from './profile/certificationsinfo/modals/certificationinfo.modal';
import { NgbIdentitiesinfoModal } from './profile/identitiesinfo/modals/identitiesinfo.modal';
import { NgbEducationInfoModal } from './profile/educationinfo/modals/educationinfo.modal';
import { NgbEmployeeHistoryInfoModal } from './profile/employeehistoryinfo/modals/employeehistoryinfo.modal';
import { NgbMedicalFitnessinfoModal } from './profile/medicalfitnessinfo/modals/medicalfitnessinfo.modal';
import { NgbActorFormsModal } from './actorforms/modals/actorforms.modal';
import { CustomDataByRequestTypeListComponent } from '../../custumcomponents/ddlbyrequesttype/customdatabyrequesttypelist.componenet';
import { ActorReportsComponent } from './actorforms/actorforms.component';
import { ActorFormDetailsComponent } from './actorforms/formdetails/actorformdetails.component';

import { NurseSidebarComponent } from './layout/sidebar/nursesidebar.component';
import { CertificationsInfoComponent } from './profile/certificationsinfo/certificationsinfo.component';
import { NgbContactInfoModal } from './profile/contactinfo/modals/ngbcontactinfo.modal';
import { ContactInfoComponent } from './profile/contactinfo/contactinfo.component';
import { EducationInfoComponent } from './profile/educationinfo/educationinfo.component';
import { EmployeeHistoryInfoComponent } from './profile/employeehistoryinfo/employeehistoryinfo.component';
import { IdentitiesInfoComponent } from './profile/identitiesinfo/identitiesinfo.component';
import { NgbLegalInfoModal } from './profile/legalinfo/modals/legalinfo.modal';
import { LegalInfoComponent } from './profile/legalinfo/legalinfo.component';
import { MedicalFitnessInfoComponent } from './profile/medicalfitnessinfo/medicalfitnessinfo.component';
import { NgbChangePasswordModal } from './profile/modals/changepassword/changepassword.modal';
import { NgbPersonalInfoModal } from './profile/personalinfo/modals/ngbpersonalinfo.modal';
import { PersonalInfoComponent } from './profile/personalinfo/personalinfo.component';
import { NgbProfessionalReferenceInfoModal } from './profile/professionalreference/modals/professionalreference.modal';
import { ProfessionalReferencesInfoComponent } from './profile/professionalreference/professionalreference.component';
import { MyProfessionalReferencesComponent } from './profile/professionalreference/myprofessionalreference/myprofessionalreference.component';
import { NgbProfilesummaryInfoModal } from './profile/profilesummary/modals/profilesummary.modal';
import { ProfileSummaryInfoComponent } from './profile/profilesummary/profilesummary.component';
import { NgbScheduleAssistantModal } from './testnurse2/scheduleassistant/scheduleassistant.modal';
import { DateFormatPipe, UTCDatePipe } from '../../pipes/dateformat.pipe';
import { DateTimeFormatPipe } from '../../pipes/datetimeformat.pipe';
import { LimitWordPipe } from '../../pipes/limitword.pipe';
import { BoldPipe } from '../../pipes/textbold.pipe';
import { ActorCredentialConfigPipe } from '../../pipes/configs/actorcredentialconfig.pipe';
import { DocRenewConfigPipe } from '../../pipes/configs/docrenewconfig.pipe';
import { EventRegistrationPipe } from '../../pipes/events/eventregistration.pipe';
import { ActorRoleDutyPipe } from '../../pipes/masters/actorroleduty.pipe';
import { CodeTypePipe } from '../../pipes/masters/codetype.pipe';
import { CodeTypeValuePipe } from '../../pipes/masters/codetypevalue.pipe';
import { FacilitiesPipe } from '../../pipes/masters/facilities.pipe';
import { NurseProfilesInfoByRegistryPipe } from '../../pipes/registry/nurseprofileinfobyregistry.pipe';
import { InstantReportsConfigPipe } from '../../pipes/reports/instantreportsconfig.pipe';
import { PersonalDetailInfoComponent } from './profile/personaldetailinfo/personaldetailinfo.component';
import { OtherDataComponent } from './profile/otherdata/otherdata.component';
import { VitalsInfoComponent } from './profile/vitals/vitals.component';
import { ObservationsComponent } from './profile/observations/observations.component';
import { EmergencyComponent } from './profile/Emergency/emergency.component';
import { GuardianComponent } from './profile/guardian/guardian.component';
import { EmergencyViewComponent } from './profile/patientprofileview/emergencyview/emergencyview.component';
import { GuardianViewComponent } from './profile/patientprofileview/guardianview/guardianview.component';
import { ObservationsViewComponent } from './profile/patientprofileview/observationsview/observationsview.component';
import { PersonalDetailViewComponent } from './profile/patientprofileview/personaldetailview/personaldetailview.component';
import { ProfileViewComponent } from './profile/patientprofileview/profileview.component';
import { ProviderDashboardComponent } from './provider/dashboard/providerdashboard.component';
import { ActorVitalFormComponent } from './actorforms/vitalforms/actorvitalform.component';
import { ServiceComponent, ServiceConfigurationInfoPipe } from './service/service.component';
import { ViewGeneralComponent } from './service/view-general/view-general.component';
import { ViewConsultantComponent } from './service/view-consultant/view-consultant.component';
import { ViewBranchComponent } from './service/view-branch/view-branch.component';
import { ServiceConfigComponent } from './service/serviceconfig/serviceconfig.component';
import { NgbEditCategoryModal } from './service/modals/editcategory.modal';
import { NgbAddCategoryModal } from './service/modals/addcategory.modal';
import { NgbAddBranchModal } from './service/view-branch/modal/addbranch.modal';
import { NgbEditBranchModal } from './service/view-branch/modal/editbranch.modal';
import { NgbAddConsultantModal } from './service/view-consultant/modal/addconsultant.modal';
import { NgbEditConsultantModal } from './service/view-consultant/modal/editconsultant.modal';
import { NgbAddServiceModal } from './service/view-general/modal/addservice.modal';
import { NgbEditServiceModal } from './service/view-general/modal/editservice.modal';
import { CounsellingregistryComponent } from './follow up/counsellingregistry/counsellingregistry.component';
import { NgbCounsellingRegistryModal } from './follow up/counsellingregistry/modal/counsellingregistry.modal';
import { ActivityTrackingComponent } from './follow up/activitytracking/activitytracking.component';
import { ActivityMonitoringComponent } from './follow up/activitytracking/activitymonitoring.component';
import { BillingComponent } from '../billing/billing.component';
import { SchedularComponent } from '../schedular/schedular.component';
import { LabComponent } from '../lab/lab.component';
import { MedicalRecordComponent } from './profile/patientprofileview/medicalrecord/medicalrecord.component';
import { NgbDocumentModal } from './profile/otherdata/documents/documents.modal';
import { NewsComponent } from './News/news.component';
import { ArticlesComponent } from './Articles/articles.component';
import { NgbEditProfileModal } from './profile/patientprofileview/personaldetailview/modal/editprofile.modal';
import { NgbEditGuardianModal } from './profile/patientprofileview/personaldetailview/modal/editguardian.modal';
import { NgbEditEmergencyModal } from './profile/patientprofileview/personaldetailview/modal/editemergency.modal';
import { NgbAddNewPatient } from './provider/dashboard/modal/addnewpatient.modal';
import { NgbAddEmergencyModal } from './profile/patientprofileview/personaldetailview/modal/addemergency.modal';
import { NgbNewsModal } from './News/modal/news.modal';
import { NgbSearchPatientModal } from './follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbActivityMonitoringModal } from './follow up/activitytracking/activitymonitoringmodal/activitymonitoring.modal';
import { NgbEditCounsellingPlanModal } from './follow up/counsellingregistry/modal/editcounsellingplan.modal';
import { NgbEditActivityMonitoringModal } from './follow up/activitytracking/activitymonitoringmodal/editactivitymonitoring.modal';
import { NgbViewCounsellingPlanModal } from './follow up/counsellingregistry/modal/viewcounsellingplan.modal';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BGSComponent } from './service/Bgs/bgs.component';
import { NgbEditBGSModal } from './service/Bgs/editbgs.modal';
import { NgbAddPackageModal } from './service/Bgs/modal/addpackage.modal';
import { NgbEditPackageModal } from './service/Bgs/modal/editpackage .modal';
import { TreatmentCycleComponent } from './ivf/TreatmentCycle/treatmentcycle.component';
import { NgbTcDetailsModal } from './ivf/TreatmentCycle/tcdetails.modal';
import { NgbEventAddModal, TestsInfoPipe } from './ivf/TreatmentCycle/eventadd.modal';
import { IVFDashboardComponent } from './ivf/ivfdashboard/ivfdashboard.component';
import { ViewEditTextComponent } from './profile/patientprofileview/medicalrecord/viewedittext.component';
import { FollicularScanComponent } from './ivf/TreatmentCycle/follicularscan.component';
import { VisitregisterComponent } from './visitregister/visitregister.component';
import { CodetypesComponent } from './codetypes/codetypes.component';
import { NgbAddCodedtypeModal } from './codetypes/modal/addcodedtype.modal';
import { NgbEditcodedtypeModal } from './codetypes/modal/editcodedtype.modal';
import { FdappointmentComponent } from './fdappointment/fdappointment.component';
import { NgbGuestPatientModal } from './fdappointment/modal/guestpatient.modal';
import { NgbRegisteredPatientModal } from './fdappointment/modal/registeredpatient.modal';
import { NgbTypeofPatientModal } from './fdappointment/modal/typeofpatient.modal';
import { LabsetupComponent } from './labsetup/labsetup.component';
import { NgbAddTestsModal } from './labsetup/modals/addtests.modal';
import { NgbAddNotesModal } from './labsetup/modals/addnotes.modal';
import { NgbEditObservationModal } from './labsetup/modals/editobservation.modal';
import { NgbEditSpecimenModal } from './labsetup/modals/editspecimen.modal';
import { NgbEditTestinfoModal } from './labsetup/modals/edittestinfo.modal';
import { TestinformationComponent } from './labsetup/testinformation/testinformation.component';
import { OpBillingComponent } from './opbilling/opbilling.component';
import { ReceiptComponent } from './opbilling/receipt.component';
import { NgbAddBill } from './opbilling/modal/addbill.modal';
import { NgbTestRangeModal } from './labsetup/testinformation/modals/testrange.modal';
import { PickUpComponent } from './ivf/TreatmentCycle/pickup.component';
import { EtViewComponent } from './ivf/TreatmentCycle/etview.component';
import { SpermCollectionComponent } from './ivf/TreatmentCycle/spermcollection.component';
import { InseminationComponent } from './ivf/TreatmentCycle/insemination.component';
import { IVFWorkBenchComponent } from './ivf/ivfworkbench/ivfworkbench.component';
import { ScansOfTheDayComponent } from './ivf/ivfworkbench/scansoftheday.component';
import { IvfPickupEditComponent } from './ivf/ivfworkbench/ivfpickupedit.component';
import { IvfETEditComponent } from './ivf/ivfworkbench/ivfetedit.component';
import { IvfSemananeditComponent } from './ivf/ivfworkbench/ivfsemananedit.component';
import { IvfInseminationEditComponent } from './ivf/ivfworkbench/ivfinseminationedit.component';
import { IvfOQAeditComponent } from './ivf/ivfworkbench/ivfoqaedit.component';
import { IvfGradingeditComponent } from './ivf/ivfworkbench/ivfgradingedit.component';
//import { IvfGradingeditComponent } from './ivf/ivfworkbench/ivfgradingedit .component';
import { NgbEditGradingModal } from './ivf/ivfworkbench/editgrading.modal';
import { FreezingComponent } from './ivf/ivfworkbench/freezing.component';
import { NgbcryostorageModal } from './ivf/ivfworkbench/cryostorage.modal';
import { IvfGradingeditCellComponent } from './ivf/ivfworkbench/ivfgradingcelledit.component';
import { CryoStorageNewComponent } from './ivf/ivfworkbench/cryostoragenew.component';
import { CalendarComponent } from './calendar/calendar.component';
import { SessionComponent } from './session/session.component';
import { NgbAddSession } from './session/modal/addsession.modal';
import { NgbEditSession } from './session/modal/editsession.modal';
import { NgxPrintModule } from 'ngx-print';
import { PrintService } from '../../services/print.service';
//import { NgxPageScrollModule } from 'ngx-page-scroll';
//import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
//import { TestPrintServicesComponent } from './service/test-printlayout/testprintservices.component';
//import { TestPrintlayoutComponent } from './service/test-printlayout/testprintlayout.component';
import { MISComponent } from './ivf/ivfworkbench/mis.component';
import { BarGraphComponent } from './ivf/ivfworkbench/bargraph.component';
import { LineGraphComponent } from './ivf/ivfworkbench/linegraph.component';
import { PieGraphComponent } from './ivf/ivfworkbench/piegraph.component';
import { DoughnutGraphComponent } from './ivf/ivfworkbench/doughnut.component';
import { PolarareaGraphComponent } from './ivf/ivfworkbench/polarareagraph.component';
import { NgbEditOvaryModal } from './ivf/ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from './ivf/ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from './ivf/ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from './ivf/ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from './ivf/ivfworkbench/editscantest.modal';
import { NgbNewCycleModal } from './ivf/ivfdashboard/newcycle.modal';
import { NgbViewMedicineTestModal } from './ivf/TreatmentCycle/viewmedicinetest.modal';
import { NgbPayBillModal } from './opbilling/paybill.modal';
import { NgbSearchDonarModal } from './ivf/TreatmentCycle/searchdonar.modal';
import { NgbSearchProviderModal } from './ivf/ivfworkbench/searchprovider.modal';
import { UsersComponent } from './users/users.component';
import { NgbAddPickUpMedicineModal } from './ivf/ivfworkbench/addpickupmedicine.modal';
import { NgbAddPickUpTestModal } from './ivf/ivfworkbench/addpickuptest.modal';
import { NgbSelectActivityModal } from './ivf/TreatmentCycle/selectactivity.modal';
import { IvfmasterlistComponent } from './ivf/ivfmasterlist.component';
import { NgbAddactivitytemplateModal } from './ivf/addactivitytemplate.modal';
import { NgbEditactivitytemplateModal } from './ivf/editactivitytemplate.modal';
import { NgbAddactivitiesModal } from './ivf/addactivities.modal';
import { NgbEditactivitiesModal } from './ivf/editactivities.modal';
import { ElsTimePickerComponent } from './fdappointment/ElsTimePicker/ElsTimePicker.component';
import { NgbSearchDonarreModal } from './ivf/TreatmentCycle/searchdonarre.modal';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { NgbAddInseminationLogModal } from './ivf/ivfworkbench/addinseminationlog.modal';
import { NgbEditInseminationLogModal } from './ivf/ivfworkbench/editinseminationlog.modal';
import { CycleActivitiesComponent, Activity2Pipe } from './ivf/ivfworkbench/cycleactivities.component';
import { NgbFsEditAttrModal } from './profile/patientprofileview/medicalrecord/modal/fseditattr.modal';
import { NgbFsEditTextModal } from './profile/patientprofileview/medicalrecord/modal/fsedittext.modal';
import { NgbFsEditImageModal } from './profile/patientprofileview/medicalrecord/modal/fseditimage.modal';
import { NgbFsEditViewModal } from './profile/patientprofileview/medicalrecord/modal/fseditview.modal';
import { AutoGenTextComponent } from './profile/patientprofileview/medicalrecord/comps/autogentext.component';
import { AutoGenCvsComponent } from './profile/patientprofileview/medicalrecord/comps/autogencvs.component';
import { AutoGenBoolComponent } from './profile/patientprofileview/medicalrecord/comps/autogenbool.component';
import { AutoGenDateComponent } from './profile/patientprofileview/medicalrecord/comps/autogendate.component';
import { AutoGenChildrenComponent } from './profile/patientprofileview/medicalrecord/comps/autogenchildren.component';
import { AutoGenListComponent } from './profile/patientprofileview/medicalrecord/comps/autogenlist.component';
import { IvfPickupReadyEditComponent } from './ivf/ivfworkbench/ivfpickupreadyedit.component';
import { AutoSection1Component } from './profile/patientprofileview/medicalrecord/comps/autosection1.component';
import { XYChartsComponent } from './ivf/ivfworkbench/xycharts.component';
import { AutoGenCsvListComponent } from './profile/patientprofileview/medicalrecord/comps/autogencsvlist.component';
import { AutoGenGradeComponent } from './profile/patientprofileview/medicalrecord/comps/autogengrade.component';
import { AutoGenListHComponent } from './profile/patientprofileview/medicalrecord/comps/autogenlisth.component';
import { NgbAddFormsModal } from './profile/patientprofileview/medicalrecord/modal/addforms.modal';
import { NgbUpdateCycleStatusModal } from './ivf/ivfdashboard/updatecyclestatus.modal';
import { OqaViewComponent } from './ivf/TreatmentCycle/oqaview.component';
import { MedicineViewComponent } from './ivf/ivfworkbench/medicineview.component';
import { TestViewComponent } from './ivf/ivfworkbench/testview.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbEggStorageModal } from './ivf/TreatmentCycle/eggstorage.modal';
import { IvfPregnancyEditComponent } from './ivf/ivfworkbench/ivfpregnancyedit.component';
import { ReferralViewComponent } from './profile/patientprofileview/referralview/referralview.component';
import { NgbAddReferralModal } from './profile/patientprofileview/referralview/modal/addreferral.modal';
import { NgbPartnerDetails } from './profile/patientprofileview/personaldetailview/modal/partnerdetails.modal';
import { VisitViewComponent } from './profile/patientprofileview/medicalrecord/visitview.component';
import { PatinetTestViewComponent } from './profile/patientprofileview/medicalrecord/patienttestview.component';
import { NgbEditOqaModal } from './ivf/ivfworkbench/editoqa.modal';
import { NgbEditAbnormalOqaModal } from './ivf/ivfworkbench/editabnormaloqa.modal';
import { NgbEditInsemiModal } from './ivf/ivfworkbench/editinsemi.modal';
import { NgbEditGradingDayModal } from './ivf/ivfworkbench/editgradingday.modal';
import { NgbAddOqaModal } from './ivf/ivfworkbench/addoqa.modal';
import { NgbAddAbnormalOqaModal } from './ivf/ivfworkbench/addabnormaloqa.modal';
import { ivfembryogradingdropletComponent } from './ivf/ivfworkbench/ivfembryogradingdroplet.component';
import { NgbCameraUploadModal } from './profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { WebcamModule } from 'ngx-webcam';
import { NgbEditGradingFetModal } from './ivf/ivfworkbench/editgradingfet.modal';
import { NgbEditGradingFetDetailModal } from './ivf/ivfworkbench/editgradingfetdetail.modal';
import { NgbEditGradingetModal } from './ivf/ivfworkbench/editgradinget.modal';
import { AutoGenGridComponent } from './profile/patientprofileview/medicalrecord/comps/autogengrid.component';
import { NgbFsEditGridRowModal } from './profile/patientprofileview/medicalrecord/modal/fseditgridrow.modal';
import { AnalysisChartsComponent, RemoveCommaPipe } from './ivf/ivfworkbench/analysischarts.component';
import { NgbEmbryoStoreLocationModal } from './ivf/ivfworkbench/embryostorelocation.modal';
import { BillProfileComponent } from './opbilling/billprofile.component';
import { BillViewComponent } from './opbilling/billview.component';
import * as PlotlyJS from 'plotly.js-dist-min';
import { PlotlyModule, PlotlyViaWindowModule } from 'angular-plotly.js';

(window as any).Plotly = PlotlyJS;
PlotlyModule.plotlyjs = PlotlyJS;
import { IvfHelpComponent } from './help/ivfhelp.component';
import { IvfHelpScansComponent } from './help/ivfhelpscans.component';
import { NgbPaymentModal } from './opbilling/modal/payment.modal';
import { OpBillingEditComponent } from './opbilling/opbillingedit.component';
import { CryoPreservationComponent } from './ivf/ivfworkbench/cryopreservation.component';
import { NgbSpecimenCollection } from '../lab/specimencollection.modal';
import { NgbSign } from '../lab/sign.modal';
import { NgbResult } from '../lab/results.modal';
import { VendorsComponent } from './erpsetup/vendors.component';
import { NgbAddVendorModal } from './erpsetup/modal/addvendor.modal';
import { NgbEditVendorModal } from './erpsetup/modal/editvendor.modal';
import { NgbAddCredentialsModal } from './erpsetup/modal/addcredentials.modal';
import { NgbEditCredentialsModal } from './erpsetup/modal/editcredentials.modal';
import { NgbAddsuplMaterialsModal } from './erpsetup/modal/addsuplmaterials.modal';
import { NgbEditsuplMaterialsModal } from './erpsetup/modal/editsuplmaterials.modal';
import { CodeTypeValueService } from '../../custumcomponents/codetypes/codetypevalue.service';
import { ItemCatalogueComponent } from './opbilling/itemcatalogue.component';
import { CustomerOrdersComponent } from './opbilling/customerorders.component';
import { ViewOrderComponent } from './opbilling/vieworder.component';
import { ExternaldoctorsComponent } from './masters/externaldoctors.component';
import { EmployeeComponent } from './masters/employee.component';
import { DepartmentsComponent } from './masters/departments.component';
import { BranchesComponent } from './masters/branches.component';
import { ModuleComponent } from './users/module.component';
import { RolesComponent } from './users/roles.component';
import { FeaturesComponent } from './users/features.component';
import { AccessRightsComponent } from './users/accessrights.component';
import { ReportAttributesComponent } from './reportsetup/reportattributes.component';
import { ReportRegisterComponent } from './reportsetup/reportregister.component';
import { NgbEditItemsModal } from './opbilling/modal/edititems.modal';
import { CUstomDataByRequestTypeService } from '../../custumcomponents/ddlbyrequesttype/customdatabyrequesttype.service';
import { FollicularScan2Component } from './ivf/TreatmentCycle/follicularscan2.component';
import { NgbFollicularEditModal } from './ivf/TreatmentCycle/follicularedit.modal';
import { TreatmentCycle2Component } from './ivf/TreatmentCycle/treatmentcycle2.component';
import { PickUp2Component } from './ivf/TreatmentCycle/pickup2.component';
import { NgbTriggerEditModal } from './ivf/TreatmentCycle/triggeredit.modal';
import { NgbPickupEditModal } from './ivf/TreatmentCycle/pickupedit.modal';
import { OqaView2Component } from './ivf/TreatmentCycle/oqaview2.component';
import { NgbOqaviewEditModal } from './ivf/TreatmentCycle/oqaviewedit.modal';
import { SpermCollection2Component } from './ivf/TreatmentCycle/spermcollection2.component';
import { NgbSemanEditModal } from './ivf/TreatmentCycle/semanedit.modal';
import { Insemination2Component } from './ivf/TreatmentCycle/insemination2.component';
import { NgbInseminationEditModal } from './ivf/TreatmentCycle/inseminationedit.modal';
import { EtView2Component } from './ivf/TreatmentCycle/etview2.component';
import { NgbGradingEditModal } from './ivf/TreatmentCycle/gradingedit.modal';
import { ivfembryogradingdroplet2Component } from './ivf/ivfworkbench/ivfembryogradingdroplet2.component';
import { NgbTrEtEditModal } from './ivf/TreatmentCycle/tretedit.modal';
import { GradingViewComponent } from './ivf/TreatmentCycle/gradingview.component';
import { FreezingViewComponent } from './ivf/TreatmentCycle/freezingview.component';
import { NgbFreezingEditModal } from './ivf/TreatmentCycle/freezingedit.modal';
import { NgbPregencyEdittModal } from './ivf/TreatmentCycle/pregencyedit.modal';
import { PregencyTrackerComponent } from './ivf/TreatmentCycle/pregencytracker.component';
import { IVFDashboard2Component } from './ivf/ivfdashboard/ivfdashboard2.component';
import { NgbAddbilladv } from '../../../../../src/app/ncs/modules/testnurse/opbilling/modal/addbilladv.modal';
import { ApprovalListComponent } from './opbilling/approvallist.component';
import { RefundreqItemsComponent } from './opbilling/refundreqitems.component';
import { ExpenseVocherComponent } from './opbilling/expensevocher.component';
import { NgbAddExpensesDetailsModal } from './opbilling/modal/addexpensesdetails.modal';
import { ExpenseManComponent } from './opbilling/expenseman.component';
import { NgbViewItemDetailsModal } from './opbilling/modal/viewitemdetails.modal';
import { ReaderComponent } from './provider/dashboard/reader.component';
import { ServicesViewComponent } from './profile/patientprofileview/medicalrecord/servicesview.component';
import { IOHReceiptComponent } from './opbilling/iohreceipt.component';
import { IOHOrdersComponent } from './opbilling/iohorders.component';
import { IOHViewOrderComponent } from './opbilling/iohvieworder.component';
import { ConsumptionEntryDasComponent } from './consumptionentry/consumptionentrydas.component';
import { ConsumptionReceiptComponent } from './consumptionentry/consumptionreceipt.component';
import { MaterialConsumptionComponent } from './erpsetup/materialconsumption.component';
import { NgbAddConsumptiongroupModal } from './erpsetup/modal/addconsumptiongroup.modal';
import { NgbEditConsumptiongroupModal } from './erpsetup/modal/editconsumptiongroup.modal';
import { NgbBatchDetailModal } from './consumptionentry/batchdetail.modal';
import { NgbAddGroupItemModal } from './erpsetup/modal/addgroupitem.modal';
import { ConsumptionReceiptEditComponent } from './consumptionentry/consumptionreceiptedit.component';
import { FdappointmentAdvComponent } from './fdappointment/fdappointment(adv).component';

import { ChartModule } from 'primeng/chart';

import { HorizontalBarGraphComponent } from './ivf/ivfworkbench/horizontalbargraph.component';
import { RadarGraphComponent } from './ivf/ivfworkbench/radargraph.component';
import { NgbGraphTableViewModal } from './consumptionentry/graphtableview.modal';
import { ReceiptOldComponent } from './opbilling/receiptold.component';
import { ReceiptEditComponent } from './opbilling/receiptedit.component';
import { RxReceiptComponent } from './opbilling/rxreceipt.component';
import { NgbBatchDetail2Modal } from './consumptionentry/batchdetail2.modal';
import { NgbPatientBillsModal } from './follow up/counsellingregistry/modal/patientbills.modal';
import { RefundReceiptComponent } from './opbilling/refundreceipt.component';
import { CyclesProfileComponent } from './opbilling/cyclesprofile.component';
import { NgbActorDocs2Modal } from './profile/modals/actordocs/actordocs2.modal';
import { PrescriptionviewComponent } from './profile/patientprofileview/medicalrecord/prescriptionview.component';
import { PrescriptionreceiptComponent } from './opbilling/prescriptionreceipt.component';
import { NgbAddPrescriptionMedicineModal } from './opbilling/modal/addprescriptionmedicine.modal';
import { NgbEditPrescriptionMedicineModal } from './opbilling/modal/editprescriptionmedicine.modal';
import { NgbAddArticleModal } from './Articles/modal/addarticle.modal';
import { OrdersProfileComponent } from './opbilling/ordersprofile.component';
import { TableGraphComponent } from './ivf/ivfworkbench/tablegraph.component';
import { NgbPaymentRefundModal } from './opbilling/modal/paymentrefund.modal';
import { RefundsDashboardComponent } from './opbilling/refundsdashboard.component';
import { RefundItemsComponent } from './opbilling/refundItems.component';

import { AdmissionsComponent } from './admissions/admissions.component';
import { NewAdmissionComponent } from './admissions/newadmission.component';
import { EditAdmissionComponent } from './admissions/editadmission.component';
import { NgbErpSetupModal } from './profile/patientprofileview/personaldetailview/modal/erpsetup.modal';
import { AmountToWordPipe } from '../printing/print-layout/ivf-printview/A5/A5rxbill.component';
import { ViewPharmBillingComponent } from './opbilling/viewpharmbilling.component';
import { LabDashboardComponent } from '../lab/labdashboard.component';
import { SpecimenCollection2Component } from '../lab/specimencollection2.component';
import { NgbPaymentModeChangeModal } from './opbilling/modal/paymentmodechange.modal';
import { RxreceipteditComponent } from './opbilling/rxreceiptedit.component';
import { ResultsEntryComponent } from '../lab/resultsentry.component';
import { ServicesAdmissionComponent } from './admissions/servicesadmission.component';
import { IohAdmissionreceiptComponent } from './admissions/iohadmissionreceipt.component';
import { MedicinesAdmissionComponent } from './admissions/medicinesadmission.component';
import { BillAdmissionComponent } from './admissions/billadmission.component';
import { NgbAddDiscountModal } from './opbilling/modal/adddiscount.modal';
import { IpReceiptComponent } from './admissions/ipreceipt.component';
import { MaterialTrackingComponent } from './erpsetup/materialtracking.component';
import { BillVerficationComponent } from './opbilling/billverfication.component';
import { NgbServiceTrackingModal } from './opbilling/modal/servicetracking.modal';
import { QRCodeModule } from 'angularx-qrcode';
import { IPBillServicesTrackingComponent } from './opbilling/ipbillservicestracking.component';
import { OPBillServicesTrackingComponent } from './opbilling/opbillservicestracking.component';
import { ServicesRevenueComponent } from './erpsetup/servicesrevenue.component';
import { MaterialInvoiceComponent } from './opbilling/materialinvoice.component';
import { InvoiceReceiptComponent } from './opbilling/invoicereceipt.component';
import { NgbGoodsInvoiceModal } from './opbilling/modal/goodsinvoice.modal';
//import { InvoiceReceiptEditComponent } from './opbilling/invoicereceiptedit.component';
import { InvoiceEditComponent } from './opbilling/invoiceedit.component';
import { IpBillVerficationComponent } from './opbilling/ipbillverfication.component';
import { ServiceTrackingReportComponent } from './opbilling/servicetrackingreport.component';
import { ExcelReportingComponent } from './Reporting/excelreporting.component';
import { NewDashboardComponent } from './dashboard/newdashboard.component';
import { DocDashboardComponent } from './dashboard/docdashboard.component';
import { DashboardSectionContainerComponent } from './ivf/ivfworkbench/dashboardsectioncontainer.component';
import { NgbRxSearchPatientModal } from './follow up/counsellingregistry/modal/rxsearchpatient.modal';
import { NgbCustomizeDashboardModal } from './dashboard/customizedashboard.modal';
import { SmartPhoneMenuComponent } from './dashboard/smartphonemenu.component';
import { SmartPhonefdAppointmentComponent } from './fdappointment/smartphonefdappointment(adv).component';
import { SmartPhoneDocAppointmentsComponent } from './fdappointment/sp_doctorappointments.component';
import { NgbAOEServiceModal } from './admissions/aoeservice.modal';
import { NgbCategoryChangeModal } from './admissions/categorychange.modal';
import { NgbEditMaterialbatchModal } from './erpsetup/modal/editmaterialbatch.modal';
import { PurchaseIndentComponent } from './opbilling/purchaseindent.component';
import { IndentAddComponent } from './opbilling/indentadd.component';
import { PurchaseOrderComponent } from './opbilling/purchaseorder.component';
import { PurchaseOrderEditComponent } from './opbilling/purchaseorderedit.component';
import { PurchaseOrderAddComponent } from './opbilling/purchaseorderadd.component';
import { NgbSearchPurchaseIndentsModal } from './opbilling/modal/searchpurchaseindents.modal';
import { NgbSearchVendorsModal } from './opbilling/modal/searchvendors.modal';
import { NgbEditPOitemsModal } from './opbilling/modal/editPOitems.modal';
import { NgbEditPOitems2Modal } from './opbilling/modal/editPOitems2.modal';
import { MyWorkBookComponent } from './follow up/activitytracking/myworkbook.component';
import { DeptConsumptionEntryDasComponent } from './consumptionentry/deptconsumptionentrydas.component';
import { DeptConsumptionReceiptComponent } from './consumptionentry/deptconsumptionreceipt.component';
import { DeptConsumptionReceiptEditComponent } from './consumptionentry/deptconsumptionreceiptedit.component';
import { NgbAddNewEnquiry } from './provider/dashboard/modal/addnewenquiry.modal';
import { NgbPartnerSearchpatientModal } from './follow up/counsellingregistry/modal/partnersearchpatient.modal';
import { NgbAddNewServiceModal } from './profile/patientprofileview/personaldetailview/modal/addnewservice.modal';
import { NgbEditActivityMonitoring2Modal } from './follow up/activitytracking/activitymonitoringmodal/editactivitymonitoring2.modal';
import { ServicesPanelComponent } from './service/servicespanel.component';
import { NgbEditServicesModal } from './profile/patientprofileview/personaldetailview/modal/editservices.modal';
import { ActivityMonitoring2Component } from './follow up/activitytracking/activitymonitoring2.component';
import { NgbOPSearchProviderModal } from './follow up/counsellingregistry/modal/opsearchprovider.modal';
import { NgbSearchPurchaseOrdersModal } from './opbilling/modal/searchpurchaseorders.modal';
import { NgbEditPIitemsModal } from './opbilling/modal/editPIitems.modal';
import { CombinedBillingComponent } from './opbilling/combinedbilling.component';
import { CombinedAddBillingComponent } from './opbilling/combinedaddbilling.component';
import { NgbCombinebillSearchPatientModal } from './follow up/counsellingregistry/modal/combinebillsearchpatient.modal';
import { NgbCopyMaterialbatchModal } from './erpsetup/modal/copymaterialbatch.modal';
import { NgbReturnMaterialbatchModal } from './erpsetup/modal/returnmaterialbatch.modal';
import { NgbVerifyMaterialbatchModal } from './erpsetup/modal/verifymaterialbatch.modal';
import { NgbEditPIitems2Modal } from './opbilling/modal/editPIitems2.modal';
import { ReceiptServiceProviderComponent } from './opbilling/receipt_svcprovider.component';
import { ReceiptEditServiceProviderComponent } from './opbilling/receiptedit_svcprovider.component';
import { CustDashboardComponent } from './dashboard/custdashboard.component';
import { ProfileViewHComponent } from './profile/patientprofileview/profileviewh.component';
import { NgbCustEditProfileModal } from './profile/patientprofileview/personaldetailview/modal/custeditprofile.modal';
import { NgbCustSearchProviderModal } from './ivf/ivfworkbench/custsearchprovider.modal';
import { NgbFacilitywise_ProviderCostModal } from './follow up/counsellingregistry/modal/facilitywise_providercost.modal';
import { NgbAOEditServiceModal } from './admissions/aoeditservice.modal';
import { IPReceiptEditServiceProviderComponent } from './opbilling/IPreceiptedit_svcprovider.component';
import { NgbTransferMaterialbatchModal } from './erpsetup/modal/transfermaterialbatch.modal';
import { OPServicesComponent } from './admissions/opservices.component';
import { OPServicesHistoryComponent } from './admissions/opserviceshistory.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { PatientProfileViewComponent } from './profile/patientprofileview/patientprofileview.component';
import { POVIComponent } from './opbilling/povi.component';
import { POVIAddComponent } from './opbilling/poviadd.component';
import { POVIEditComponent } from './opbilling/poviedit.component';
import { NgbEditPOVIitemsModal } from './opbilling/modal/editPOVIitems.modal';
import { NgbEditPOVIitems2Modal } from './opbilling/modal/editPOVIitems2.modal';
import { NgbEditMaterialDetailsModal } from './erpsetup/modal/editmaterialdetails.modal';
import { NgbSel_ApptdetailsModal } from './fdappointment/sel_apptdetails.modal';
import { PurchaseOrderAdd_DiscComponent } from './opbilling/purchaseorderadd_disc.component';
import { PurchaseOrderEdit_DiscComponent } from './opbilling/purchaseorderedit_disc.component';
import { InvoiceReceipt_DiscComponent } from './opbilling/invoicereceipt_disc.component';
import { InvoiceEdit_DiscComponent } from './opbilling/invoiceedit_disc.component';
import { NgbAddOPServiceModal } from './opbilling/modal/addopservice.modal';
import { NgbChangeDateModal } from './opbilling/modal/changedate.modal';
import { ProfileViewPartnerComponent } from './profile/patientprofileview/profileviewpartner.component';
import { NgbAddPartnerModal } from './profile/patientprofileview/personaldetailview/modal/addpartner.modal';
import { NgbEditCodetypeValueModal } from '../../custumcomponents/codetypes/modal/editcodetypevalue.modal';
import { NgbEditCodetypeValue2Modal } from '../../custumcomponents/codetypes/modal/editcodetypevalue2.modal';
import { IvfAdditionalDetailComponent } from './ivf/TreatmentCycle/ivfadditionaldetail.component';
import { NgbIvfAdditionalDetailEditModal } from './ivf/TreatmentCycle/ivfadditionaldetailedit.modal';
import { NgbEditCycleModal } from './ivf/TreatmentCycle/editcycle.modal';
import { NgbEditCycleActivitiesModal } from './ivf/TreatmentCycle/editcycleactivities.modal';
import { NgbSplitPaymentModal } from './opbilling/modal/splitpayment.modal';
import { EggDonorDashboardComponent } from './ivf/ivfdashboard/eggdonordashboard.component';
import { EggDonorEpisodeComponent } from './ivf/TreatmentCycle/eggdonorepisode.component';
import { NgbNewEpisodeModal } from './ivf/ivfdashboard/newepisode.modal';
import { NgbSearchDonarEpisodeModal } from './ivf/TreatmentCycle/searchdonarepisode.modal';
import { NgbSearchCyclesModal } from './follow up/counsellingregistry/modal/searchcycles.modal';
import { FollicularScansDashboardComponent } from './ivf/ivfdashboard/follicularscansdashboard.component';
import { FollicularScanEpisodeComponent } from './ivf/TreatmentCycle/follicularscanepisode.component';
import { NgbNewFollicularScanEpisodeModal } from './ivf/ivfdashboard/newfollicularscanepisode.modal';
import { OpBillingNPComponent } from './opbilling/opbillingnp.component';
import { OpBillingPPComponent } from './opbilling/opbillingpp.component';
//import { ExpenseManagementComponent } from './opbilling/expensemanagement.component';
//import { NgbAddExpensesDetailsModal } from './profile/patientprofileview/personaldetailview/modal/addexpensesdetails.modal';
//import { ApprovalsComponent } from './opbilling/approvals.component';
//import { NgbEmbryoStoreLocationModal } from './ivf/ivfworkbench/embryostorelocation.modal';
//import { NgbFsEditGridRowModal } from './profile/patientprofileview/medicalrecord/modal/fseditgridrow';
//import { OnlynumberDirective } from './numbersonly/only-numeric.directive';
//import { TreatmentCycleComponent } from './ivf/TreatmentCycle/treatmentcycle';
//import { NgbEditPackageModal } from './service/Bgs/modal/editpackage.modal';
//import { NgbEditGuardianModal } from './profile/patientprofileview/personaldetailview/modal/editguradian.modal';
//import { CounsellingRegisterComponent } from './followup/counsellingregister/counsellingregister.component';
//const nurseroutes: Routes = [
//  {
//    path: 'testnurse', component: TestnurseComponent,

//    children: [
//      {
//        path: 'list',
//        component: Testnurse2Component
//      },

//    ]
//  }
//];
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  declarations: [
    TestnurseComponent,
    IvfPickupReadyEditComponent,
    RefundsDashboardComponent,
    OrdersProfileComponent,
    XYChartsComponent,
    ExpenseVocherComponent,
    SpecimenCollection2Component,
    LabDashboardComponent,
    NgbAddExpensesDetailsModal,
    ViewPharmBillingComponent,
    ReceiptOldComponent,
    NgbViewItemDetailsModal,
    NgbPatientBillsModal,
    NgbAddPrescriptionMedicineModal,
    NgbBatchDetail2Modal,
    NgbPaymentRefundModal,
    InvoiceEditComponent,
    NgbErpSetupModal,
    NgbEditPrescriptionMedicineModal,
    RxReceiptComponent,
    TableGraphComponent,
    ServicesRevenueComponent,
    MaterialInvoiceComponent,
    NgbBatchDetailModal,
    ResultsEntryComponent,
    ExpenseManComponent,
    FdappointmentAdvComponent,
    PrescriptionviewComponent,
    RefundReceiptComponent,
    //ExpenseManagementComponent,
    //  ExpenseManagementComponent,
    // OnlynumberDirective,
    OqaViewComponent,
    Refundslistpipe,
    Testnurse2Component,
    RefundItemsComponent,
    PickUp2Component,
    ReaderComponent,
    ConsumptionEntryDasComponent,
    PrescriptionreceiptComponent,
    CyclesProfileComponent,
    ConsumptionReceiptComponent,
    ServicesViewComponent,
    IvfmasterlistComponent,
    RxreceipteditComponent,
    IOHOrdersComponent,
    IOHViewOrderComponent,
    AutoSection1Component,
    IvfHelpComponent,
    OqaView2Component,
    IvfHelpScansComponent,
    ReceiptEditComponent,
    MedicineViewComponent,
    TestViewComponent,
    IOHReceiptComponent,
    GradingViewComponent,
    RefundreqItemsComponent,
    FreezingViewComponent,
    NgbTrEtEditModal,
    CustomerOrdersComponent,
    NgbFreezingEditModal,
    ViewOrderComponent,
    //ApprovalsComponent,
    ApprovalListComponent,
    AutoSection1Component,
    PregencyTrackerComponent,
    ConsumptionReceiptEditComponent,
    Insemination2Component,
    ivfembryogradingdropletComponent,
    ivfembryogradingdroplet2Component,
    ServiceTrackingReportComponent,
    SpermCollection2Component,
    ElsTimePickerComponent,
    CycleActivitiesComponent,
    TreatmentCycle2Component,
    IVFDashboard2Component,
    ConsumptionEntrypipe,
    RadarGraphComponent,
    IpReceiptComponent,
    HorizontalBarGraphComponent,
    // TestPrintServicesComponent,
    //TestPrintlayoutComponent,
    FreezingComponent,
    NgbAddactivitytemplateModal,
    NgbFsEditGridRowModal,
    NgbEditactivitytemplateModal,
    NgbEditGradingFetDetailModal,
    NgbActorDocs2Modal,
    NgbOqaviewEditModal,
    NgbAddbilladv,
    //NgxPageScrollModule,
    //NgxPageScrollCoreModule,
    NgbAddactivitiesModal,
    NgbFsEditAttrModal,
    NgbFsEditTextModal,
    NgbFsEditImageModal,
    NgbInseminationEditModal,
    EtView2Component,
    NgbGradingEditModal,
    Activity2Pipe,
    Storelistpipe,
    NgbFsEditViewModal,
    NgbTriggerEditModal,
    NgbGraphTableViewModal,
    InvoiceReceiptComponent,
    NgbEditOqaModal,
    NgbEditAbnormalOqaModal,
    NgbEditItemsModal,
    NgbAddAbnormalOqaModal,
    NgbEditGradingetModal,
    NgbAddOqaModal,
    NgbAddFormsModal,
    NgbAddReferralModal,
    NgbPartnerDetails,
    NgbCameraUploadModal,
    NgbEditactivitiesModal,
    NgbSearchDonarreModal,
    NgbAddPackageModal,
    NgbEggStorageModal,
    NgbEmbryoStoreLocationModal,
    NgbRegisteredPatientModal,
    IvfGradingeditCellComponent,
    PickUpComponent,
    CryoStorageNewComponent,
    NgbcryostorageModal,
    NgbViewMedicineTestModal,
    NgbPaymentModal,
    NgbEditGradingFetModal,
    IvfGradingeditComponent,
    CryoPreservationComponent,
    CalendarComponent,
    SessionComponent,
    MISComponent,
    BarGraphComponent,
    OpBillingEditComponent,
    NgbSemanEditModal,
    UsersComponent,
    UsersListPipe,
    PickPipe2,
    LineGraphComponent,
    PieGraphComponent,
    DoughnutGraphComponent,
    PolarareaGraphComponent,
    EtViewComponent,
    SpermCollectionComponent,
    NgbAddInseminationLogModal,
    InseminationComponent,
    NgbTypeofPatientModal,
    NgbEditGradingModal,
    NgbSearchProviderModal,
    IvfSemananeditComponent,
    IvfInseminationEditComponent,
    NgbAddScanMedicineModal,
    NgbAOEServiceModal,
    NgbCategoryChangeModal,
    AnalysisChartsComponent,
    NgbAddPickUpMedicineModal,
    NgbAddPickUpTestModal,
    NgbGoodsInvoiceModal,
    NgbEditScanMedicineModal,
    IvfOQAeditComponent,
    ServiceComponent,
    IVFDashboardComponent,
    ItemCatalogueComponent,
    IVFWorkBenchComponent,
    ScansOfTheDayComponent,
    ViewGeneralComponent,
    ViewConsultantComponent,
    FollicularScanComponent,
    NgbTcDetailsModal,
    LabsetupComponent,
    TestinformationComponent,
    OpBillingComponent,
    ReceiptComponent,
    NgbAddBill,
    NgbUpdateCycleStatusModal,
    NgbEditSession,
    NgbEditInsemiModal,
    NgbEditGradingDayModal,
    NgbAddSession,
    NgbSearchDonarModal,
    FdappointmentComponent,
    ViewEditTextComponent,
    NgbAddTestsModal,
    NgbAddNotesModal,
    NgbPickupEditModal,
    NgbEditObservationModal,
    NgbAddScanTestModal,
    NgbTestRangeModal,
    NgbEditSpecimenModal,
    NgbEditTestinfoModal,
    NgbNewCycleModal,
    OPBillServicesTrackingComponent,
    NgbPayBillModal,
    NgbPaymentModeChangeModal,
    NewsComponent,
    DashboardComponent,
    ArticlesComponent,
    NgbEventAddModal,
    BillingComponent,
    RemoveCommaPipe,
    //NgbEditPackageModal,
    NgbEditPackageModal,
    NgbEditcodedtypeModal,
    MedicalRecordComponent,
    VisitViewComponent,
    PatinetTestViewComponent,
    SchedularComponent,
    MaterialTrackingComponent,
    LabComponent,
    CodetypesComponent,
    BGSComponent,
    ViewBranchComponent,
    ActivityTrackingComponent,
    ActivityMonitoringComponent,
    ServiceConfigComponent,
    NgbGuestPatientModal,
    TreatmentCycleComponent,
    NurseCustomizerComponent,
    VisitregisterComponent,
    PersonalDetailInfoComponent,
    CertificationsV2InfoComponent,
    NgbSearchPatientModal,
    NgbActivityMonitoringModal,
    NgbSelectActivityModal,
    //CounsellingRegisterComponent,
    ContactInfoComponent,
    EducationInfoComponent,
    //ServiceConfigurationInfoPipe2,
    EmployeeHistoryInfoComponent,
    IdentitiesInfoComponent,
    DriverV2InfoComponent,
    DriverInfoV3Component,
    MyIdentitiesComponent,
    FollicularScan2Component,
    NgbFollicularEditModal,
    ServiceCategoryPipe,
    ItemsIahpipe,
    ConsultantMapPipe,
    ExpenseVoucherpipe,
    OocytePipe,
    NgbViewCounsellingPlanModal,
    NgbAddCodedtypeModal,
    ResumeUploadComponent,
    EducationInfoV2Component,
    EmployeeHistoryInfoV2Component,
    MedicalFitnessInfoV2Component,
    NgbMyScheduleModal,
    NgbAddNewPatient,
    NgbNewsModal,
    NgbEditScanTestModal,
    ActorFormsV2Component,
    IvfPickupEditComponent,
    IvfETEditComponent,
    IvfPregnancyEditComponent,
    NgbAddCategoryModal,
    NgbAddEmergencyModal,
    NgbAddBranchModal,
    NgbEditEmergencyModal,
    NgbEditGuardianModal,
    NgbDocumentModal,
    NgbEditBranchModal,
    NgbEditProfileModal,
    NgbAddConsultantModal,
    NgbEditConsultantModal,
    NgbEditCounsellingPlanModal,
    NgbEditServiceModal,
    NurseNavbarComponent,
    AllCertificateListComponent,
    JobApplicationsInfoPipe,
    BillingPipe,
    Servicebillpipe,
    DoctorListPipe,
    ScansPipe,
    IahPipe,
    // IahItemsPipe,
    ActivitesPipe,
    //billingpipe,
    ActorIdentitiesPipe,
    NurseFooterComponent,
    ActorReportsComponent,
    ActorFormDetailsComponent,
    NgbEditBGSModal,
    NurseSidebarComponent,
    CertificationsInfoComponent,
    CustomDataByRequestTypeListComponent,
    IpBillVerficationComponent,
    //ActorFormsV3Component,
    ServiceConfigurationInfoPipe,
    CataloguePipe,
    AllCertificatesViewPipe,
    NurseProfileComponent,
    LocationComponent,
    Shiftsinfov2Component,
    Equipmentinfov2Component,
    SpecialtyInfoV2Component,
    EmploymentTypeComponent,
    MappedRegistriesByNurseInfoPipe,
    DateFormatPipe,
    UTCDatePipe,
    DateTimeFormatPipe,
    LimitWordPipe,
    BoldPipe,
    CredentialTypePipe,
    NgbEditInseminationLogModal,
    NgbEditActivityMonitoringModal,
    NgbEditOvaryModal,
    IPBillServicesTrackingComponent,
    SplitPipe,
    NgbdUploadActorImageModal,
    NgbEditCategoryModal,
    ActorImageInfoComponent,
    MyScheduleManagerShortComponent,
    MyScheduleManagerComponent,
    LegalInfoComponent,
    MedicalFitnessInfoComponent,
    MyJobsPendingComponent,

    DocRenewAlertsInfoComponent,

    ActorFormsV3Component,
    NgbActorDocsModal,
    NgbCertificationsinfoModal,
    NgbIdentitiesinfoModal,
    NgbEducationInfoModal,
    NgbEmployeeHistoryInfoModal,
    NgbMedicalFitnessinfoModal,
    NgbActorFormsModal,
    NgbContactInfoModal,
    NgbLegalInfoModal,
    NgbChangePasswordModal,
    NgbPersonalInfoModal,
    NgbAddDiscountModal,
    PersonalInfoComponent,
    NgbProfessionalReferenceInfoModal,
    ProfessionalReferencesInfoComponent,

    MyProfessionalReferencesComponent,
    NgbProfilesummaryInfoModal,
    ProfileSummaryInfoComponent,
    NgbScheduleAssistantModal,
    NgbAddServiceModal,
    ActorCredentialConfigPipe,
    PatientListPipe,
    PatientListPipe2,
    DocRenewConfigPipe,
    EventRegistrationPipe,
    ActorRoleDutyPipe,
    CodeTypePipe,
    CodeTypeValuePipe,
    ScansPipe,
    OocyteAbPipe,
    ActivitesPipe,
    MedicinePipe,
    TestsInfoPipe,
    TestPipe,
    PickPipe,
    Approvallistpipe,
    InseminationPipe,
    GradingPipe,
    EtPipe,
    AccessRightPipe,
    SemanPipe,
    Drugslistpipe,
    PregencyTrackerPipe,
    TestViewPipe,
    CodeTypePipeNew,
    CodeValuesPipeNew,
    FacilitiesPipe,
    NurseProfilesInfoByRegistryPipe,
    InstantReportsConfigPipe,
    OtherDataComponent,
    VitalsInfoComponent,
    ObservationsComponent,
    EmergencyComponent,
    GuardianComponent,
    EmergencyViewComponent,
    GuardianViewComponent,
    ReferralViewComponent,
    ObservationsViewComponent,
    PersonalDetailViewComponent,
    ProfileViewComponent,
    ProviderDashboardComponent,
    ActorVitalFormComponent,
    CounsellingregistryComponent,
    NgbCounsellingRegistryModal,
    AutoGenTextComponent,
    AutoGenCvsComponent,
    AutoGenBoolComponent,
    AutoGenDateComponent,
    AutoGenChildrenComponent,
    AutoGenListComponent,
    AutoGenCsvListComponent,
    AutoGenGradeComponent,
    AutoGenListHComponent,
    AutoGenGridComponent,
    BillProfileComponent,
    BillViewComponent,
    NgbSpecimenCollection,
    NgbPregencyEdittModal,
    NgbSign,
    NgbResult,
    VendorsComponent,
    NgbAddVendorModal,
    NgbEditVendorModal,
    NgbAddCredentialsModal,
    NgbEditCredentialsModal,
    NgbAddsuplMaterialsModal,
    NgbEditsuplMaterialsModal,
    ExternaldoctorsComponent,
    EmployeeComponent,
    DepartmentsComponent,
    BranchesComponent,
    ModuleComponent,
    RolesComponent,
    FeaturesComponent,
    AccessRightsComponent,
    UsersComponent,
    NgbMyScheduleModal,
    NgbScheduleAssistantModal,
    ReportAttributesComponent,
    BillVerficationComponent,
    NgbServiceTrackingModal,
    ReportRegisterComponent,
    MaterialConsumptionComponent,
    NgbAddConsumptiongroupModal,
    NgbEditConsumptiongroupModal,
    NgbAddGroupItemModal,
    NgbAddArticleModal,
    Externallistpipe,
    Providerlistpipe,
    AdmissionsComponent,
    NewAdmissionComponent,
    EditAdmissionComponent,
    AmountToWordPipe,
    ServicesAdmissionComponent,
    IohAdmissionreceiptComponent,
    MedicinesAdmissionComponent,
    BillAdmissionComponent,
    ExcelReportingComponent,
    NewDashboardComponent,
    DocDashboardComponent,
    DashboardSectionContainerComponent,
    NgbRxSearchPatientModal,
    NgbCustomizeDashboardModal,
    SmartPhoneMenuComponent,
    SmartPhonefdAppointmentComponent,
    SmartPhoneDocAppointmentsComponent,
    NgbEditMaterialbatchModal,
    PurchaseIndentComponent,
    IndentAddComponent,
    PurchaseOrderComponent,
    PurchaseOrderEditComponent,
    PurchaseOrderAddComponent,
    NgbSearchPurchaseIndentsModal,
    MaterialSpecpipe,
    NgbSearchVendorsModal,
    NgbEditPOitemsModal,
    NgbEditPOitems2Modal,
    MyWorkBookComponent,
    DeptConsumptionEntryDasComponent,
    DeptConsumptionReceiptComponent,
    DeptConsumptionReceiptEditComponent,
    NgbAddNewEnquiry,
    NgbPartnerSearchpatientModal,
    NgbAddNewServiceModal,
    NgbEditActivityMonitoring2Modal,
    ServicesPanelComponent,
    NgbEditServicesModal,
    ActivityMonitoring2Component,
    NgbOPSearchProviderModal,
    NgbSearchPurchaseOrdersModal,
    NgbEditPIitemsModal,
    CombinedBillingComponent,
    CombinedAddBillingComponent,
    NgbCombinebillSearchPatientModal,
    NgbCopyMaterialbatchModal,
    NgbReturnMaterialbatchModal,
    NgbVerifyMaterialbatchModal,
    NgbEditPIitems2Modal,
    ReceiptServiceProviderComponent,
    ReceiptEditServiceProviderComponent,
    CustDashboardComponent,
    ProfileViewHComponent,
    NgbCustEditProfileModal,
    NgbCustSearchProviderModal,
    NgbFacilitywise_ProviderCostModal,
    NgbAOEditServiceModal,
    IPReceiptEditServiceProviderComponent,
    NgbTransferMaterialbatchModal,
    OPServicesComponent,
    OPServicesHistoryComponent,
    PatientProfileViewComponent,
    POVIComponent,
    POVIAddComponent,
    POVIEditComponent,
    NgbEditPOVIitemsModal,
    NgbEditPOVIitems2Modal,
    NgbEditMaterialDetailsModal,
    NgbSel_ApptdetailsModal,
    PurchaseOrderAdd_DiscComponent,
    PurchaseOrderEdit_DiscComponent,
    InvoiceReceipt_DiscComponent,
    InvoiceEdit_DiscComponent,
    NgbAddOPServiceModal,
    NgbChangeDateModal,
    ProfileViewPartnerComponent,
    NgbAddPartnerModal,
    NgbEditCodetypeValueModal,
    NgbEditCodetypeValue2Modal,
    IvfAdditionalDetailComponent,
    NgbIvfAdditionalDetailEditModal,
    NgbEditCycleModal,
    NgbEditCycleActivitiesModal,
    NgbSplitPaymentModal,
    EggDonorDashboardComponent,
    EggDonorEpisodeComponent,
    NgbNewEpisodeModal,
    NgbSearchDonarEpisodeModal,
    NgbSearchCyclesModal,
    FollicularScansDashboardComponent,
    FollicularScanEpisodeComponent,
    NgbNewFollicularScanEpisodeModal,
    OpBillingNPComponent,
    OpBillingPPComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MappedRegistriesByNurseInfoPipe,
    SplitPipe,
    AutoGenTextComponent,
    AutoGenCvsComponent,
    AutoGenBoolComponent,
    AutoGenDateComponent,
    AutoGenChildrenComponent,
    AutoGenListComponent,
    AutoGenCsvListComponent,
    AutoGenGradeComponent,
    AutoGenListHComponent,
    AutoGenGridComponent,
    NgbdUploadActorImageModal,
    ActorImageInfoComponent,
    NurseFooterComponent,
    NurseProfilesInfoByRegistryPipe,
    AmountToWordPipe
  ],
  imports: [
    SharedModule,
    AutocompleteLibModule,    
    CommonModule,
    FormsModule,
    NgxPrintModule,
    NgxSpinnerModule,
    PlotlyViaWindowModule,
    ChartModule,
    WebcamModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    NgxMaskDirective,
    NgxMaskPipe,
    NgxMaterialTimepickerModule,
    ReactiveFormsModule,
    InfiniteScrollModule,
    TestnurseRoutingModule,
    QRCodeModule,
    NgbModule,
    RouterModule.forChild([
      {
        path: 'testnurse', component: TestnurseComponent, canActivate: [AuthGuard],

        children: [
          //{ path: 'dashboard', component: TestnurseDashboard, canActivate: [AuthGuard] },
          {
            path: 'schedulemanager', component: MyScheduleManagerComponent, canActivate: [AuthGuard]
          },
          //{ path: 'jobrecommends', component: JobRecommendsComponent, canActivate: [AuthGuard] },
        ]

      },
    ])

  ],

  providers: [
    provideNgxMask(),
    TranslateModule,
    //Toastr and auth providers
    // { provide: ToastOptions, useClass: CustomOption },
    AuthService,
    AuthGuard,
    ActorService,
    CodeTypeValueService,
    CUstomDataByRequestTypeService,
    DOCService,
    HCPService,
    FDService,
    LoginService,
    ActorIdentitiesPipe,
    BillingPipe,
    TestsInfoPipe,
    Storelistpipe,
    RemoveCommaPipe,
    DateFormatPipe,
    OocyteAbPipe,
    UTCDatePipe,
    ScansPipe,
    Refundslistpipe,
    Providerlistpipe,
    ConsumptionEntrypipe,
    AccessRightPipe,
    Approvallistpipe,
    //billingpipe,
    ActivitesPipe,
    Servicebillpipe,
    Drugslistpipe,
    OocytePipe,
    PickPipe2,
    UsersListPipe,
    PickPipe,
    ItemsIahpipe,
    Externallistpipe,
    IahPipe,
    // IahItemsPipe,
    InseminationPipe,
    CodeTypePipeNew,
    CodeValuesPipeNew,
    DateTimeFormatPipe,
    DoctorListPipe,
    PatientListPipe,
    PatientListPipe2,
    MappedRegistriesByNurseInfoPipe,
    ServiceCategoryPipe,
    ConsultantMapPipe,
    ExpenseVoucherpipe,
    //ServiceConfigurationInfoPipe2,
    TranslateService,
    CataloguePipe,
    ServiceConfigurationInfoPipe,
    AllCertificatesViewPipe,
    JobApplicationsInfoPipe,
    CredentialTypePipe,
    MedicinePipe,
    Activity2Pipe,
    GradingPipe,
    EtPipe,
    SemanPipe,
    PregencyTrackerPipe,
    TestPipe,
    TestViewPipe,
    CustomDateTimeService,
    NurseProfilesInfoByRegistryPipe,
    PrintService,
    AmountToWordPipe,
    MaterialSpecpipe,
  ]
})
export class TestnurseModule {
  constructor() {
    PlotlyModule.plotlyjs = PlotlyJS;
  }
}

